import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  height: 100vh;
  width: 100%;
  position: relative;
  padding: 0 ${spacing(10)};

  .logo-container {
    display: flex;
    align-items: center;
    height: 120px;
  }

  .footer {
    margin-top: ${spacing(12)};
    padding-bottom: ${spacing(15)};
  }
`
